import React, {
   forwardRef,
   useEffect,
   useImperativeHandle,
   useState,
} from 'react'
import {
   Card,
   CardContent,
   Typography,
   RadioGroup,
   FormControlLabel,
   Radio,
   Button,
   Box,
} from '@mui/material'
import parseLatexString from '../../utils/latextParser'
import { useApiExam } from '../../api'
import { jwtDecode } from 'jwt-decode'
import { useNavigate } from 'react-router-dom'

const Quiz = forwardRef(({ data }, ref) => {
   const navigate = useNavigate()
   const [index, setIndex] = useState(0)
   const [answers, setAnswers] = useState({})
   const [currentOption, setCurrentOption] = useState(null)

   const decoded = jwtDecode(sessionStorage.getItem('exam_token'))

   const { post_exam, get_exam, put_exam } = useApiExam()
   const API_BASE_URL = process.env.REACT_APP_API_URL

   const currentQuestion = data[index]

   const handleAnswerChange = (id, label) => {
      console.log(id, label)
      setCurrentOption({
         option_id: id,
         option: label,
      })
      setAnswers({ ...answers, [currentQuestion.id]: id })
   }

   const handlePrev = () => {
      if (index > 0) setIndex(index - 1)
   }

   const handleNext = async () => {
      console.log(index, currentOption)
      if (currentOption) {
         await post_exam(API_BASE_URL + '/exam/save_answer', {
            exam_id: decoded?.exam_id,
            exam_participant_id: decoded?.exam_participant_id,
            question_id: currentQuestion?.id,
            option_id: currentOption?.option_id,
            answer: currentOption?.option,
         })
            .then((res) => {
               console.log(res)
            })
            .catch((err) => {
               console.error(err)
            })
            .finally(() => {
               console.log('done')
            })
      }
      if (index < data.length - 1) setIndex(index + 1)
      setCurrentOption(null)
   }

   const handleSubmit = async () => {
      console.log('test')
      console.log('Jawaban user:', answers)

      await put_exam(
         API_BASE_URL + `/exam/finish?id=${decoded?.exam_participant_id}`,
         {
            is_finished: true,
         }
      )
         .then((res) => {
            console.log(res)
         })
         .catch((err) => {
            console.error(err)
         })
         .finally(() => {
            console.log('done')
            navigate('/exam/result')
         })
   }

   useEffect(() => {
      get_exam(
         `/exam/get_answer?exam_id=${decoded?.exam_id}&exam_participant_id=${decoded?.exam_participant_id}`
      )
         .then((res) => {
            console.log(res)
            const answers_mapped = res?.answers?.reduce((acc, cur) => {
               acc[cur.question_id] = cur.option_id
               return acc
            }, {})
            setAnswers(answers_mapped)
         })
         .catch((err) => {
            console.error('Error fetching exam answer:', err)
         })
         .finally(() => {
            console.log('done')
         })
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   // kasih akses ke parent
   useImperativeHandle(ref, () => ({
      handleSubmit,
   }))

   return (
      <Card sx={{ maxWidth: 600, margin: 'auto', mt: 5, p: 2 }}>
         <CardContent>
            <Typography variant="h6" gutterBottom>
               {index + 1}. {parseLatexString(currentQuestion.question)}
            </Typography>

            <RadioGroup value={answers[currentQuestion.id] || ''}>
               {currentQuestion.options.map((opt) => (
                  <FormControlLabel
                     key={opt.id}
                     value={opt.id}
                     control={<Radio />}
                     label={parseLatexString(opt.option)}
                     onChange={() => handleAnswerChange(opt.id, opt.option)}
                  />
               ))}
            </RadioGroup>

            <Box
               display="flex"
               justifyContent="space-between"
               alignItems="center"
               mt={3}
            >
               <Button
                  variant="contained"
                  onClick={handlePrev}
                  disabled={index === 0}
               >
                  ⬅️
               </Button>

               {index === data.length - 1 && (
                  <Button
                     variant="contained"
                     color="success"
                     onClick={handleSubmit}
                  >
                     Submit
                  </Button>
               )}

               <Button
                  variant="contained"
                  onClick={handleNext}
                  // disabled={index === data.length - 1}
               >
                  ➡️
               </Button>
            </Box>
         </CardContent>
      </Card>
   )
})

export default Quiz
